import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  ClientResponse,
  CompanyClientResponse,
  LoginRequest,
  LoginResponse,
  RoleResponse,
  SocietyResponse,
  User,
  UserResponse,
} from "../../types/api.types";
import { LoginFormData } from "../../components/LoginForm";

export const userService = {
  getUsers: async (): Promise<User[]> => {
    const response = await apiClient.get<ApiResponse<User[]>>(
      ENDPOINTS.USERS.GET_ALL,
    );
    return response.data.data;
  },
  createUser: async (userData: any): Promise<UserResponse> => {
    const response = await apiClient.post<ApiResponse<UserResponse>>(
      ENDPOINTS.USERS.CREATE,
      userData,
    );
    return response.data.data;
  },
  getUserById: async (id: string): Promise<User> => {
    const response = await apiClient.get<ApiResponse<User>>(
      ENDPOINTS.USERS.GET_BY_ID,
      { params: { userId: id } },
    );
    return response.data.data;
  },
  updateUser: async (userData: any): Promise<UserResponse> => {
    const response = await apiClient.put<ApiResponse<UserResponse>>(
      ENDPOINTS.USERS.UPDATE,
      userData,
    );
    return response.data.data;
  },
  deactivateUser: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.USERS.DEACTIVATE,
      {},
      { params: { id } },
    );
    return response.data;
  },
  activateUser: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.USERS.ACTIVATE,
      {},
      { params: { id } },
    );
    return response.data;
  },
  getCompanies: async (
    token: string = "",
  ): Promise<CompanyClientResponse[]> => {
    const response = await apiClient.get<ApiResponse<CompanyClientResponse[]>>(
      ENDPOINTS.USERS.GET_COMPANIES,
      {
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      },
    );
    return response.data.data;
  },
};
